<template>
	<div class="i-array-sort">
		<table border="1">
			<tbody>
				<tr  v-for="(item,i) in val">
					<td>{{item.label}}</td>
					<td style='width:96px;text-align:center;'>
						<btn i="chevron-up" @press="move(i,i-1)" :disabled="i==0"/>
						<btn i="chevron-down" @press="move(i,i+1)" :disabled="i==val.length-1"/>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	methods:{
		move(old,nw){
			let {val} = this;
		    if (nw >= val.length) {
		        var k = nw - val.length + 1;
		        while (k--) {
		            val.push(undefined);
		        }
		    }
		    val.splice(nw, 0, val.splice(old, 1)[0]);
		    this.val =  val;
		    this.$emit('input', val.map(a=>a.name))
		}
	},
	mounted(){
		//console.log(this.value, this.elements)
		//console.log(typeof this.value)
		if(!this.value || typeof this.value !== "object" || this.value.length!== this.elements.length) {
			this.val = this.elements;
		} else {
			console.log(111)
			this.val = this.value.map((i)=>{
				return this.elements.find(a=>a.name === i);
			});
		}
	},
  name: 'i-array-editor',
  props: {
  	value: {type:Array},
  	elements: {type:Array, default(){
  		return [
			{"label":"Основной долг", name:"main_debt", type:"debt"},
			{"label":"Просроченный ОД", name:"overdue_debt", type:"debt"},
			{"label":"Вознаграждение", name:"fine", type:"debt"},
  		];
  	}},
  	mode: {type:String, default:"all"} // values, keys
  },
  data () {
    return {
    	val:[]
    }
  }
}
</script>

<style lang="css" scoped>
table{
	border-collapse: collapse;
	width:100%;
}

td{
	padding:4px;
}
</style>